import React, { Component } from 'react';
import { List, Image, Popup, Checkbox, Label, Divider } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';
import EllipsisTooltip from './../../common/EllipsisTooltip';
import defaultLogo from "../../../images/logo/logo-128.png";
import { source } from 'react-aim';
import _ from 'lodash';

@source({
    mouseEnter: (props, component) => dispatch.app.setHelpContext("Account Selection")
})

class AccountSelector extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false
        }
    }

    markDefault(e, data, accountId) {
        let payload = {
            accountId: accountId,
            default: data.checked
        }
        dispatch.account.setDefaultAccount(payload);
    }

    async selectAccount(e, d, payload) {
        this.setState({ isOpen: false })
        if (this.props.selectedAccount._id !== payload.id) {
            dispatch.invite.clear();
            dispatch.register.clear();
            dispatch.profile.clear();
            dispatch.forgot.clear();
            dispatch.reset.clear();
            dispatch.organizationUnit.clear();
            dispatch.organizationTab.clear();
            dispatch.community.clear();
            dispatch.users.clear();
            dispatch.lifeCycle.clear();
            dispatch.initiatives.clear();
            dispatch.content.clear();
            dispatch.createPack.clear();
            dispatch.notifications.clear();
        }
        if (payload.role === "user" && payload.isActive === false) {
            dispatch.account.setAccountSelectorLoader(true);
            await dispatch.account.selectAccount({ accountId: payload.id });
            dispatch.account.setDeActivateAccountModal(true);
            dispatch.account.getAcountUserWorkspaces({isLoaderEnabled:true})
            await dispatch.notifications.getEventStreamByOrganization({});
        } else if (payload.role === "platformAdmin") {
            await dispatch.account.selectAccount({ accountId: payload.id });
            this.props.history.push('/app/platform/home')
        } else {
            dispatch.account.setAccountSelectorLoader(true);
            await dispatch.account.selectAccount({ accountId: payload.id });
            await dispatch.app.setAllOrganizationsAndRedirectToDefault({ accountId: payload.id });
            dispatch.account.setAccountSelectorLoader(false);
            dispatch.account.getAcountUserWorkspaces({});
            await dispatch.notifications.getEventStreamByOrganization({});
        }

    }
    handleOpen = () => {
        this.setState({ isOpen: !this.state.isOpen });
        dispatch.account.getAllAccounts();
    }

    handleClose = () => {
        this.setState({ isOpen: false })
    }

    viewAllAccount = () => {
        dispatch.account.setViewAccountFlag(true);
        this.setState({ isOpen: false })
    }


    render() {
        const { setAccountName, selectedAccount, user } = this.props
        let account = user && user.accounts.filter((account, i) => { return account.id === selectedAccount._id });
        let role = account && account[0] && account[0].role ? account[0].role : null;
        let isDefault = account && account[0] && account[0].default ? true : false;

        let allAccounts = this.props.user && this.props.user.accounts;
        let disableDefault = true;
        if (allAccounts.length > 1) {
            disableDefault = false;
        }

        let filteredAccount = [];
        if (allAccounts && allAccounts.length !== 0) {
            let p_admin = allAccounts.filter((i) => { return i.role === 'platformAdmin' });
            filteredAccount.push(p_admin)
            let c_admin = allAccounts.filter((i) => { return i.role === 'customerAdmin' })
            filteredAccount.push(c_admin)
            let u_admin = allAccounts.filter((i) => { return i.role === 'user' })
            filteredAccount.push(u_admin)
            let remaining = allAccounts.filter((i) => { return i.role !== 'platformAdmin' && i.role !== 'customerAdmin' && i.role !== 'user' })
            filteredAccount.push(remaining)
        }
        let accounts = Array.prototype.concat.apply([], filteredAccount);
        console.log(this.props.allAccounts, "this.props.allAccounts")
        console.log(allAccounts, "accounts")
        if (this.props.allAccounts.length > 0) {
            this.props.allAccounts.forEach(acc => {
                accounts.forEach(userAccount => {
                    if (acc._id.toString() === userAccount.id.toString()) {
                        userAccount.logo = acc.logo;
                        userAccount.name = acc.name;
                        userAccount.isActive = acc.isActive;
                    }
                });
            });
        }


        let accountName = <div
            id="create-account"
            className={`${accounts && accounts.length > 1 ? "dd-hover cursor-pointer" : ""} acc-box dropdown-box  account_width pad_8`}
            onMouseEnter={() => dispatch.app.setHelpContext("Account Selection")}
        >
            <div className="acc-text w_181"  >
                <div className="acc-name" style={isDefault ? { marginTop: '0' } : { marginTop: '7px' }}>
                    <EllipsisTooltip
                        name={setAccountName ? setAccountName : selectedAccount.name}
                        position="bottom left"
                    />
                </div>
                <div className="acc-role" >
                    {
                        isDefault ?
                            <span className="float-right" style={isDefault ? { margin: "-0 0px" } : { margin: "-7px 0px" }}>
                                <Label color='blue' size="mini" style={{ borderRadius: "2em" }} > Default </Label>
                            </span> : null
                    }
                </div>
            </div >
        </div >

        let accountList = accounts && accounts.map((account, index) => {
            return (

                <List.Item style={{ padding: "3px 8px"}} key={index} className='hover-item'>
                    <Image
                        src={account.logo ? account.logo : defaultLogo}
                        className="float-left accountlogo scaleDown"
                        style={{ margin: "3px 0 0 0" }} />
                    <List.Content floated='right'>
                        {
                            account.isActive ?
                                <Checkbox toggle
                                    checked={account.default}
                                    onChange={(e, d) => { this.markDefault(e, d, account.id) }}
                                    disabled={disableDefault}
                                />
                                : <Label className='bg-orange' size="mini" style={{ borderRadius: "2em" }} > Deactivated </Label>
                        }
                    </List.Content>
                    <List.Content style={{ padding: "3px 13px", margin: " 0 0 0 24px" }} >
                        <div onClick={(e, d) => { this.selectAccount(e, d, account) }}>
                            <EllipsisTooltip
                                className="float-left list-effect"
                                name={account.name}
                                style={{ cursor: "pointer", lineHeight: "16px" }}
                            />
                        </div>
                    </List.Content>
                </List.Item>
            )
        })

        return (
            <div className="display-inherit">
                {accounts && accounts.length > 1 ?
                    <Popup
                        trigger={accountName}
                        on='click'
                        open={this.state.isOpen}
                        onClose={this.handleClose}
                        onOpen={this.handleOpen}
                        style={{ padding: "10px 0 0 0" }}
                        position="bottom left"
                    >
                        <Popup.Content style={{ width: "310px" }}>
                            <List divided verticalAlign='middle' className="w_100 f_12 display-block">
                                <List.Item style={{ margin: "0px 8px 5px 8px" }}>
                                    <List.Content floated='right'>
                                        Default
                                        </List.Content>
                                    <List.Content className="ff_sb" style={{ padding: "0px 5px", margin: " 0 0 0 0" }}>
                                        Accounts &nbsp;
                                    <Label circular size="mini" color="blue">
                                            {accounts.length}
                                        </Label>
                                    </List.Content>
                                </List.Item>
                            </List>
                            <Divider style={{ margin: 0 }} />
                            <List divided verticalAlign='middle' className="w_100 f_12 display-block" style={{ overflow: "auto", maxHeight: "200px", margin: "0px 0" }}>
                                {accountList}
                            </List>
                            <Divider style={{ margin: 0 }} />
                            <List divided verticalAlign='middle' className="w_100 f_12 display-block mar_0">
                                <List.Item className="popup-view" onClick={this.viewAllAccount}>
                                    <List.Content className="clr-blue">View All</List.Content>
                                </List.Item>
                            </List>
                        </Popup.Content>
                    </Popup> :
                    accountName
                }

            </div>
        )
    }
}

export default AccountSelector;